module.exports = __webpack_public_path__ + "img/西瓜5.2bfc80ad.png";